import Ramp from '../models/Ramp'
const state = {
    ramps: [],
}

const mutations = {
    'SET_RAMPS'(state, ramps) {
        state.ramps = ramps
    },
}

const actions = {
    async set_ramps({commit}) {
        try {
            let ramps = await Ramp.list()
            commit('SET_RAMPS', ramps.data)
            return ramps.data
        } catch (e) {
            return e
        }
    },
}

const getters = {
    ramps: state => {
        return state.ramps
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
